import SettingTypes from '@/utils/setting-types'

export default {
  name: 'doctors',
  label: {
    title: '医生模块',
    icon: require('@/assets/icon-component-label_Doctors.svg'),
    limit: -1
  },
  sort: 5,
  data: {
    source_type: 'selector',
    doctors: []
  },
  settings: {
    source_type: {
      type: SettingTypes.radio_button,
      label: '数据来源',
      options: [
        { label: '手动选择', value: 'selector' },
        { label: '所有医生', value: 'all' }
      ],
    },
    doctors: {
      type: SettingTypes.custom,
      component_name: 'DoctorsSettingSelector',
      show: data => data.source_type === 'selector'
    }
  }
}